import checkRequiredFilled from './checkRequiredFilled';

// Write the forms file and trigger the event
export default async function submitForm(formId) {
  const res = await checkRequiredFilled(formId);
  const formFinished = res.formFinished ? res.formFinished : false;
  const missingField = res.missingField ? res.missingField : null;
  if (!formFinished) return { formFinished: false, missingField };
  return { formFinished: true, missingField };
}
